import { module as BaseModule } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import modular from 'modujs';
import * as modules from './modules';
import { html } from './utils/environment';
import Lenis from '@studio-freight/lenis';
import AOS from 'aos';

// Primero registramos el plugin
gsap.registerPlugin(ScrollTrigger);

const app = new modular({
	modules: modules
});

// Inicialización de Lenis
const lenis = new Lenis({
	duration: 1,
	easing: (t) => 1 - Math.pow(1 - t, 3),
	direction: 'vertical',
	smooth: true,
	smoothTouch: true,
	touchMultiplier: 2,
});
window.lenis = lenis;

// Observe body class changes to stop/start Lenis
const bodyObserver = new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
			const hasNoScroll = document.body.classList.contains('no-scroll');
			
			if (hasNoScroll) {
				lenis.stop(); // Stop scrolling when no-scroll is added
			} else {
				lenis.start(); // Resume scrolling when no-scroll is removed
			}
		}
	});
});

bodyObserver.observe(document.body, {
	attributes: true,
	attributeFilter: ['class']
});

function handleHeaderScroll(lenis) {
	const headerElement = document.querySelector('header');
	const isHomepage = document.body.classList.contains('home');
	const nav = document.querySelector('.theme-nav');
	let navIsOpen = nav.classList.contains('open');

	if (!isHomepage && !navIsOpen) { 
		lenis.on('scroll', (e) => {
			headerElement.classList.toggle('up', e.__isScrolling);
		});
	}
}

function handleAnchorLinks(lenis) {
	window.addEventListener('hashchange', () => {
		if (window.location.hash) {
			smoothScrollToAnchor(window.location.hash, lenis);
		}
	});

	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', (event) => {
			event.preventDefault();
			const targetId = anchor.getAttribute('href');
			smoothScrollToAnchor(targetId, lenis);
		});
	});
}

function initScroll(lenis) {
	//handleHeaderScroll(lenis);
	//handleAnchorLinks(lenis);
}


function raf(time) {
	lenis.raf(time);
	ScrollTrigger.update(); // Ya sincronizado, puedes mantenerlo o eliminarlo
	if (window.lazySizes) {
		window.lazySizes.loader.checkElems();
	}
	requestAnimationFrame(raf);
}


// Observar cambios en el tamaño del body
function observeBodySize(lenis) {
	const bodyElement = document.querySelector('body');

	// Se crea el observer aca, para asegurarnos que ya existe lenis
	const resizeObserver = new ResizeObserver(entries => {
		for (let entry of entries) {
			if (entry.target === bodyElement) {
				lenis.resize();
			}
		}
	});

	resizeObserver.observe(bodyElement);
}

function observeBodyClass(className, callback) {
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				if (document.body.classList.contains(className)) {
					callback();
					observer.disconnect();
				}
			}
		}
	});

	observer.observe(document.body, { attributes: true });
}





function smoothScrollToAnchor(anchor, lenis) {
	const targetElement = document.querySelector(anchor);
	if (targetElement) {
		const headerHeight = document.querySelector('header')?.offsetHeight || 0;
		const scrollY = window.scrollY;
		const targetPosition = targetElement.getBoundingClientRect().top + scrollY;

		lenis.scrollTo(targetPosition - headerHeight, {
			duration: 2.5,
			easing: (t) => {
				return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
			},
		});
	}
}


function clearStorage() {
	sessionStorage.removeItem("savedPosts");
	sessionStorage.removeItem("savedPage");
	sessionStorage.removeItem('savedLanguage');
	sessionStorage.removeItem('savePath');
	sessionStorage.removeItem('savedType'); // Añadimos esto
}


function checkAndClearStorage() {

	let isNewsRelated =
		document.body.classList.contains("ajax-no-clean") ||
		document.body.classList.contains("blog") ||
		document.body.classList.contains("archive") ||
		document.body.classList.contains("single-post") ||
		document.body.classList.contains("single-proyecto");
	
	
	if (!isNewsRelated) {
		clearStorage();
	}
}


function init() {
	app.init(app);

	html.classList.add('is-loaded');
	html.classList.add('is-ready');

	checkAndClearStorage();

	// Credits
	if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
		var args = ['%c Developed by Artsolut studio \u00A9 https://artsolut.es', 'background: #000000; padding:10px; color: #ffffff;'];
		window.console.log.apply(console, args);
	} else if (window.console) {
		window.console.log('Developed by Ártsolut estudio - https://artsolut.es');
	}
}

function initAos() {
	AOS.init({
		debug: true,
		duration: 1000, // duración por defecto en milisegundos
		offset: 0,     // offset (en px) desde el punto de activación original
		once: true,    // si la animación debe ocurrir solo una vez
		mirror: false, // si los elementos deben animarse al salir de la vista
		anchorPlacement: 'top-bottom' // define qué posición del elemento respecto a la ventana debe activar la animación
	});
}

function initForm() {
  const customSubmit = document.querySelector('.cfsubmit');
  const form = document.querySelector('.wpcf7 form');

  if (customSubmit && form) {
    console.log('customSubmit', customSubmit);
    customSubmit.addEventListener('click', function () {
      const event = new Event('submit', { bubbles: true, cancelable: true });
      form.dispatchEvent(event);
    });
  }
}


function initOnLoad() {
	init();
	initAos();
	initScroll(lenis);
	observeBodySize(lenis);
	initForm();
	requestAnimationFrame(raf);
}

document.addEventListener('DOMContentLoaded', function () {
	if (window.location.hash) {
		const targetId = window.location.hash.substring(1);
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			window.history.replaceState(null, null, ' '); // Elimina el hash de la URL temporalmente
			// Desplazamiento suave al elemento con retraso
			setTimeout(() => {
				smoothScrollToAnchor(`#${targetId}`, lenis);
				window.history.replaceState(null, null, `#${targetId}`);
			}, 2000);
		}
	}
	initOnLoad();
});